// src/components/OfflineBanner.jsx
// 2026-08-31 (Phase 2 «Офлайн видим», П3) — sticky red banner: the incident this
// phase exists for was a payment that sat in the offline queue silently in the
// browser for 5 hours, nobody knew. `offlineConfirmed` (connection-state.js, П1 —
// 2-strike debounce, the SAME source SyncStatus's "Offline" pill reads) is the
// single source of truth here — no separate detector.
//
// Hidden without a session token: an unauthenticated LoginScreen already has its
// own connectivity indication (brief).
//
// No pending-count in the text: pendingSaves is keyed by TABLE (endpoint), not by
// individual queued row — a number here would misrepresent how much is actually
// unsaved.
import { useState, useEffect } from 'react';
import { offlineConfirmed, subscribeConnection, getConnectionSnapshot } from '../lib/connection-state.js';
import { getSessionToken } from '../utils/session.js';

const BANNER_HEIGHT = 36;
const BANNER_TEXT = 'No connection - edits are NOT being saved';

function OfflineBanner() {
  // Same subscribe-to-cached-snapshot pattern as SyncStatus (see connection-state.js
  // header comment) — this state's VALUE is unused, it exists only to give React a
  // reason to re-render (Object.is bail-out when a tick changed nothing observable);
  // `offlineConfirmed` is read fresh as a live binding below, not parsed out of it.
  const [, setSnapshot] = useState(getConnectionSnapshot());
  useEffect(() => subscribeConnection(() => setSnapshot(getConnectionSnapshot())), []);

  const visible = offlineConfirmed && !!getSessionToken();

  // BlitzHeader's own sticky top reads this var (falls back to 0px) so the header
  // doesn't ride up over the banner while scrolling — the one header edit this
  // phase makes.
  useEffect(() => {
    document.documentElement.style.setProperty('--offline-banner-h', visible ? `${BANNER_HEIGHT}px` : '0px');
    return () => {
      document.documentElement.style.setProperty('--offline-banner-h', '0px');
    };
  }, [visible]);

  if (!visible) return null;
  return (
    <div
      title={BANNER_TEXT}
      style={{
        position: 'sticky', top: 0, zIndex: 101, height: BANNER_HEIGHT,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: '100%', background: 'rgba(239,68,68,0.10)', borderBottom: '1px solid rgba(239,68,68,0.30)',
        color: '#EF4444', fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 700,
      }}
    >
      {BANNER_TEXT}
    </div>
  );
}

export { OfflineBanner };
export default OfflineBanner;
